"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useReactiveReactProp = void 0;
const react_1 = __importDefault(require("react"));
const hooks_1 = require("../../hooks");
const components_1 = require("../../components");
const useReactiveReactProp = (currentHandle, filter) => {
  const {
    options
  } = (0, hooks_1.useReactifySearchContext)();
  const {
    filterStack
  } = (0, hooks_1.useFilters)();
  const reactProp = react_1.default.useMemo(() => {
    var _a, _b;
    if (filter && filter.settingsShowEmptyValues) {
      return {
        and: components_1.SENSOR_IDS
      };
    }
    return {
      and: [...components_1.SENSOR_IDS, ...((_a = options.additionalComponentIds) !== null && _a !== void 0 ? _a : []), ...((_b = filterStack === null || filterStack === void 0 ? void 0 : filterStack.options.map(filter => filter.handle)) !== null && _b !== void 0 ? _b : [])].filter(handle => handle !== currentHandle)
    };
  }, [filterStack, currentHandle, options.additionalComponentIds]);
  return reactProp;
};
exports.useReactiveReactProp = useReactiveReactProp;